import React from "react";
import { useNavigate } from "react-router-dom";
import jwt_decode from "jwt-decode";
import { TailwindToaster } from "../../components";
import { toast } from "react-hot-toast";

import useAuth from "../../hooks/useAuth";
import axios from "../../api/axios";
import { useSelector, useDispatch } from "react-redux";
import { successLogin, failedLogin, logout } from "../../redux/Actions/Actions";

const LOGIN_URL = "/user/signin";

const Login = () => {
  const state = useSelector((state) => state.UserReducer);
  const dispatch = useDispatch();
  const [userObject, setUserObject] = React.useState({});
  const [googleAuthenKey, setGoogleAuthenKey] = React.useState(null);
  const [isAuthenticating, setIsAuthenticating] = React.useState(false);
  const { auth, setAuth } = useAuth();
  const navigate = useNavigate();

  const logoutUser = async () => {
    console.log("Logout");
    dispatch(logout(state));
    localStorage.removeItem("63cea11a56a16759beca56461fe85621");
    localStorage.clear();
    navigate("/login");
  };

  const handleCallbackResponse = async (response) => {
    const googleJwtToken = response.credential;
    try {
      axios
        .post(LOGIN_URL, JSON.stringify({ googleJwt: googleJwtToken }), {
          headers: { "Content-Type": "application/json" },
        })
        .then((response) => {
          if (
            response?.data?.status === "success" &&
            response?.data?.token !== undefined
          ) {
            dispatch(successLogin(response.data));
            const accessToken = response?.data?.token;
            const aclGroup = response?.data?.aclGroup;
            setUserObject(jwt_decode(googleJwtToken));
            localStorage.setItem(
              "63cea11a56a16759beca56461fe85621",
              googleJwtToken,
            );
            setGoogleAuthenKey(userObject.email);
            document.getElementById("signInDiv").hidden = true;
            setAuth({ accessToken, aclGroup });
            if (window.location.pathname === "/login") {
              navigate("/");
            }
          } else {
            dispatch(failedLogin(response.data));
            setGoogleAuthenKey("InvalidEmailAddress");
            toast.error(response?.data?.message);
            document.getElementById("signInDiv").hidden = false;
            localStorage.clear();
          }
        })
        .catch((err) => {
          dispatch(failedLogin(err));
          console.log(err);
          if (!err?.response) {
            toast.error("No Server Response");
          } else if (err.response?.status === 400) {
            toast.error("Missing Username or Password");
          } else if (err.response?.status === 401) {
            toast.error("Unauthorized");
          } else {
            toast.error(err?.name + " - " + err?.message);
          }
        });
    } catch (err) {
      dispatch(failedLogin(err));
      console.log(err);
      if (!err?.response) {
        toast.error("No Server Response");
      } else if (err.response?.status === 400) {
        toast.error("Missing Username or Password");
      } else if (err.response?.status === 401) {
        toast.error("Unauthorized");
      } else {
        toast.error(err?.name + " - " + err?.message);
      }
    } finally {
      //
    }
  };

  // const [google, setGoogle] = React.useState(window.google);

  // React.useEffect(() => {
  //   console.log(state);
  //   console.log(google);
  //   const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
  //   try {
  //     if (google !== undefined) {
  //       google.accounts?.id.initialize({
  //         client_id: googleClientId,
  //         callback: handleCallbackResponse,
  //       });
  //       if (state.user === null) {
  //         google.accounts?.id.renderButton(
  //           document.getElementById("signInDiv"),
  //           {
  //             theme: "filled_blue",
  //             size: "medium",
  //             shape: "pill",
  //           },
  //         );
  //         google.accounts?.id.prompt();
  //       } else {
  //         toast.success("Almost there!");
  //         const googleJwtObject = jwt_decode(
  //           localStorage.getItem("63cea11a56a16759beca56461fe85621"),
  //         );
  //         setUserObject(googleJwtObject);
  //         setIsAuthenticating(true);
  //       }
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // }, [google]);

  const loadGoogleSignIn = (google) => {
    const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;
    if (google.accounts) {
      google.accounts?.id.initialize({
        client_id: googleClientId,
        callback: handleCallbackResponse,
      });
      if (state.user === null) {
        google.accounts?.id.renderButton(document.getElementById("signInDiv"), {
          theme: "filled_blue",
          size: "medium",
          shape: "pill",
        });
        google.accounts?.id.prompt();
      } else {
        toast.success("Almost there!");
        const googleJwtObject = jwt_decode(
          localStorage.getItem("63cea11a56a16759beca56461fe85621"),
        );
        setUserObject(googleJwtObject);
        setIsAuthenticating(true);
        navigate("/");
      }
    }
  };

  React.useEffect(() => {
    setTimeout(() => {
      loadGoogleSignIn(window.google);
    }, 500);
  }, []);

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });

    if (state.user && !auth?.accessToken) {
      setUserObject({});
      setGoogleAuthenKey(null);
      localStorage.clear();
    }
    try {
      // setGoogle(window.google);
    } catch (err) {
      toast.error("Something went wrong. Trying again");
      console.log(err);
      setGoogleAuthenKey("Error");
    }
  }, [googleAuthenKey]);

  return (
    <>
      <div className='min-h-full flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8'>
        <div className='max-w-md w-full space-y-8 sm:mt-5'>
          <div>
            <img
              className='mx-auto h-24 w-auto'
              src='/assets/images/logo_cropped.png'
              alt='L&amp;L'
            />
            <h2 className='mt-6 text-center text-3xl font-bold text-gray-dark'>
              Sign in to your account
            </h2>
            <p className='mt-8 text-justify text-lg text-gray-dark'>
              Business Accounts registered under{" "}
              <strong>Lands&amp;Lands</strong> only can access this resource.
            </p>
            <div className='mt-8 space-y-6 text-right'>
              {isAuthenticating ? (
                <div className='text-right' id='isAuthenticating'></div>
              ) : (
                <div className='text-right' id='signInDiv'></div>
              )}
              <TailwindToaster />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
